<template>
  <div id="app">
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
import api from "@/interface";
import { mapMutations } from "vuex";
export default {
  name: "app",
  methods: {
    ...mapMutations(["setUser"]),
    async getLoginUser() {
      let user = await api.login.info();
      let userInfo = {
        userInfo: {
          username: user.data.username,
          no: user.data.no,
          role_id: user.data.role_id,
          access: user.data.access,
        },
      };
      this.setUser(userInfo.userInfo);
      localStorage.userInfo = JSON.stringify(userInfo);
    },
  },
  created() {
    localStorage.currency = localStorage.currency
      ? localStorage.currency
      : JSON.stringify([{ _id: "ETH" }]);
    if (localStorage.getItem("Authorization")) {
      this.getLoginUser();
    }
    if (localStorage.getItem("userInfo")) {
      let user = JSON.parse(localStorage.getItem("userInfo"));
      this.setUser(user.userInfo);
    }
  },
};
</script>
